export default __webpack_public_path__ + "static/news21-923acd88390ba42ecdccc4222bf8743f.png";